import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import { Box, Button, Card, Grid, TextField } from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import { RouteComponentProps } from 'react-router';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

interface IGTRepoState {
  vin: string;
  isLoading: boolean;
}

type GTRepoProps = { appState: AppState } & ProviderContext & RouteComponentProps<{ id: string }>;

class GTRepo extends React.PureComponent<GTRepoProps, IGTRepoState> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;

  static contextType = ApplicationContext;

  state = {
    vin: ''
  } as IGTRepoState;

  public componentDidMount() {
    this.setState({
      isLoading: false
    });
  }

  deleteVqRepo = async () => {
    try {
      this.setState({ isLoading: true });
      const response = await this.caseService.DeleteVqRepoData(this.state.vin);

      if (!response.success) {
        this.setState({ isLoading: false });
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(response.message, response.message),
          {
            variant: 'warning'
          }
        );
        return;
      }
      this.setState({ isLoading: false });

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (err: any) {
      this.setState({ isLoading: false });
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  renderForm = () => {
    return (
      <ValidatorForm
        onSubmit={() => {
          this.deleteVqRepo();
        }}
      >
        <div className="m-3 text-center">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Box mb={2}>
                <TextValidator
                  fullWidth
                  id="vin"
                  name="color"
                  placeholder={this.translatorService.Tranlate('CALCULATION_DETAILS_VIN', 'Vin')}
                  value={this.state.vin}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onChange={(e: any) => {
                    this.setState({
                      vin: e.target.value.toUpperCase()
                    });
                  }}
                  validators={[
                    'required',
                    'matchRegexp:^(?=.*[0-9])(?=.*[abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ])[0-9abcdefghjklmnprstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ-]{17}$'
                  ]}
                  errorMessages={[
                    this.translatorService.Tranlate(
                      'VALIDATORS_REQUIRED',
                      'Campul este obligatoriu'
                    ),
                    this.translatorService.Tranlate(
                      'INVALID_CAR_VIN_IDENTIFICATOR',
                      "Te rugăm să te asiguri că seria de șasiu introdusă  are 17 caractere alfanumerice și nu conține spații sau literele 'O' sau 'I'!"
                    )
                  ]}
                  label={this.translatorService.Tranlate('CALCULATION_DETAILS_VIN', 'Vin')}
                  required={true}
                />
              </Box>
            </Grid>
          </Grid>
          <div className="m-3 text-center">
            <Button className="mt-3" variant="contained" color="secondary" type="submit">
              {this.translatorService.Tranlate('DELETE_VQ_REPO_DATA', 'Sterge')}
            </Button>
          </div>
        </div>
      </ValidatorForm>
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    return (
      <Fragment>
        <Card>
          <div>{this.renderForm()}</div>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
        </Card>
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(GTRepo as any));
